const Barba = require('Barba');
import * as transitions from "./transitions/index";
import {PewComponent} from "../components/pew-component";

export class AjaxComponent extends PewComponent {

    constructor(element, options) {
        super(element, options);
        this.transitionName = 'default';
        this.clickedElement = null;
        this.transitions    = {
            default: transitions.DefaultReplaceTransition,
        }
    }

    init() {
        Barba.Pjax.cacheEnabled = false;
        Barba.Pjax.start();
        /**
         * Next step, you have to tell Barba to use the new Transition
         */

        Barba.Dispatcher.on('linkClicked', (elt, e) => {
            this.clickedElement = $(elt);
            if (this.clickedElement.data('transition')) {
                this.transitionName = this.clickedElement.data('transition');
            } else {
                this.transitionName = 'default';
            }
            this.clickedElement.addClass('barba-last-clicked');
            $('body').addClass('animating');
            let headerComponent = $('#header').data('headerComponent');
            if(headerComponent && headerComponent.menu.opened){
                headerComponent.closeMenu();
            }
        });

        Barba.Dispatcher.on('newPageReady', function (currentStatus, prevStatus, HTMLElementContainer, newPageRawHtmlContent) {
            let bodyClasses = newPageRawHtmlContent.match(/body\sclass=['|"]([^'|"]*)['|"]/)[1];
            $('body').removeClass().addClass(bodyClasses + ' animating');

            if (window.ga) {
                ga('send', 'pageview');
            } else {
                //console.log('ga not ready');
            }
        });

        Barba.Pjax.getTransition = () => {
            return this.transitions[this.transitionName] ? this.transitions[this.transitionName] : this.transitions['default'];
        };

        Barba.Dispatcher.on('transitionCompleted', () => {
            $('body').removeClass('animating');
            this.updateMenu($('#menu'), $('.barba-container').data('post-id'));
            $(window).scroll();
        })
    }

    updateMenu($menu, pageId) {

        let params = {
            currentClass: 'current_page_item',
            parentClass: 'current_page_parent',
            ancestorClass: 'current_page_ancestor',
            itemSelector: '.page_item',
        };

        $menu.find(params.itemSelector).removeClass(params.currentClass + ' ' + params.parentClass + ' ' + params.ancestorClass);
        if (!pageId) return;
        var $li = $menu.find('.page-item-' + pageId);
        if ($li.length) {
            $li.addClass(params.currentClass);
            $li.parent().closest(params.itemSelector).addClass(params.parentClass);
            $li.parentsUntil($menu, params.itemSelector).addClass(params.ancestorClass);
        }
    }

}

//window.pew.addRegistryEntry({key: 'ajax', domSelector: '#barba-wrapper', classDef: AjaxComponent});

new AjaxComponent($('#barba-wrapper'));
